import PropTypes from "prop-types";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getPrefetchedPhotos } from "app/pages/Listing/productsSelector";
import { connect } from "react-redux";
import { getRobotsMetaTag } from "app/reducers/partnerSelector";

const ListingHeadMetadata = ({ prefetchedPhotos = [], robotsMetaTag = [] }) => {
	return <HeadMetadata prefetchRessources={prefetchedPhotos} robotsMetaTag={robotsMetaTag} />;
};

ListingHeadMetadata.propTypes = {
	prefetchedPhotos: PropTypes.array,
	robotsMetaTag: PropTypes.array,
};

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		prefetchedPhotos: getPrefetchedPhotos(state),
		robotsMetaTag: robotsMetaTag?.listing,
	};
};

export default connect(mapStateToProps)(ListingHeadMetadata);
